import TextField from "@mui/material/TextField";
import globalClasses from "../css/Global.module.css";
import { InputAdornment } from "@mui/material";

const InputField = (props: any) => {
  return (
    <TextField
      id={props.id}
      key={props.index ? props.index : ""}
      autoCapitalize="true"
      name={props.name}
      label={props.label}
      type={props.type ? props.type : "text"}
      value={
        props.inputvalues !== null && props.inputvalues !== undefined
          ? props.inputvalues
          : ""
      }
      className={globalClasses.textField}
      variant={props.variant ? props.variant : "outlined"}
      error={props.errormessage}
      helperText={props.message}
      size={props.size ? props.size : "small"}
      onKeyPress={props.pressevent}
      onKeyDown={props.downevent}
      onClick={props.clickevent}
      onChange={props.changeevent}
      onFocus={props.focusevent}
      onBlur={props.blurevent}
      inputProps={
        props.type === "number"
          ? { min: "0", style: { textTransform: props.uppercase? "uppercase":"none" } }
          : { style: { textTransform:  props.uppercase? "uppercase":"none"  } }
      }
      onCopy={
        props.onCopy === false
          ? (e: any) => {
              e.preventDefault();
            }
          : () => {
              return true;
            }
      }
      onPaste={
        props.onPaste === false
          ? (e: any) => {
              e.preventDefault();
            }
          : () => {
              return true;
            }
      }
      required={props.isrequired ? props.isrequired : false}
      placeholder={props.placeholder ? props.placeholder : ""}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {props.customprops ? props.customprops : ""}
          </InputAdornment>
        ),
        readOnly: props.readOnly ? props.readOnly : false,
      }}
      sx={
        props.inputSx
          ? props.inputSx
          : {
              "& .MuiInputLabel-asterisk": {
                color: "#E60000",
              },
              "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                {
                  display: "none",
                },
            }
      }
      autoComplete="off"
      fullWidth
      disabled={props.disable ? props.disable : false}
    />
  );
};

export default InputField;
